/*------------------------------------------------------------------
YouTube & Vimeo embedder
------------------------------------------------------------------*/

export default class VideoController {
  constructor(url, parameters = {}, attributes = {}) {
    // The iframe element
    this.iframe = document.createElement('iframe');
    // Extract the video data
    this.video = this.parseURL(url);
    // The video source
    this.src = (this.video.type === 'youtube') ? `https://www.youtube.com/embed/${this.video.id}?` : `https://player.vimeo.com/video/${this.video.id}?`;

    // User settings / defaults
    this.settings = {
      modestbranding: 1,
      autoplay: 1,
      rel: 0,
    };

    // The iframe attributes
    this.attributes = {
      allow: 'autoplay; encrypted-media',
      frameborder: 0,
      allowfullscreen: true,
      mozallowfullscreen: true,
      webkitallowfullscreen: true,
    }

    // Object assign settings
    for (let key in parameters) {
      if (parameters.hasOwnProperty(key)) this.settings[key] = parameters[key];
    }

    // Object assign settings
    for (let key in attributes) {
      if (attributes.hasOwnProperty(key)) this.attributes[key] = attributes[key];
    }

    // Add the video parameters to the source
    for (let key in this.settings) {
      if (typeof this.settings[key] !== 'object') {
        if (this.settings[key] === 1 && key === 'loop') this.src += `playlist=${this.video.id}&`;
        this.src += `${key}=${this.settings[key]}&`;
      }
    }

    // Set the source
    this.iframe.src = this.src;
    // Add the attributes
    for (let key in this.attributes) this.iframe.setAttribute(key, this.attributes[key]);
    // Tell us when it is loaded
    this.iframe.addEventListener('load', () => this.iframe.className = 'video-loaded');
  }

  parseURL(url) {
    url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);
    return { type: (RegExp.$3.indexOf('youtu') > -1) ? 'youtube' : 'vimeo', id: RegExp.$6 };
  }
}

// let videoEmbed = new Embed('https://www.youtube.com/watch?v=dbB-mICjkQM', { autoplay: 0 });

// $body.append(videoEmbed.render());
